import { Box } from "@chakra-ui/react";
import { FC, useMemo } from "react";

import { PageLayout } from "~/src/components/features/global/PageLayout";

export type Props = {
  siteSlug: string;
  funnelSlug: string;
};

export const FunnelEditPage: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ children, siteSlug, funnelSlug }) => {
  const breadcrumbs = useMemo(
    () => [
      { label: "設定", path: `/sites/${siteSlug}/settings` },
      {
        label: "ファネル編集",
        path: `/sites/${siteSlug}/funnels/${funnelSlug}/edit`,
      },
    ],
    [funnelSlug, siteSlug]
  );

  return (
    <PageLayout title="ファネル編集" breadcrumbs={breadcrumbs}>
      <Box mt="32px">{children}</Box>
    </PageLayout>
  );
};
